import { FC } from 'react';

import { useAppSelector } from '../../hooks/redux';

export const BonusesCard: FC = () => {
  const wallet = useAppSelector((state) => state.walletSlice);

  const formattedValue = new Intl.NumberFormat('ru-RU').format(wallet.wallet ? wallet.wallet.balance : 0);

  return (
    <div className="w-[267px] h-[130px] bg-black rounded-card flex flex-col place-content-between p-3 ">
      <p className="text-heading-lg text-accent">БОНУСНЫЙ БАЛАНС</p>
      <p className="text-display-m text-white tabular-nums">{formattedValue}</p>
    </div>
  );
};
